  		const mainMenu = document.querySelector('#mainmenu');
		const mobileMenu = document.querySelector('#mobile-menu');
		// const body = document.querySelector('body');
		const menuItems = document.querySelectorAll('li.has-submenu'); // All submenu items desktop & mobile menu
        const mobileMenuItems = mobileMenu.querySelectorAll('li.has-submenu');
		const deskMenuItems = document.querySelectorAll('#mainmenu .has-submenu');
		const menuToggle = document.querySelector('#hamburger');

		initializeMenu(); // Setup menu dropdowns
        initializeMobileMenu(); // Setup Mobile dropdowns

		initializeMouseOverEvents();

		function initializeMouseOverEvents() {
			Array.prototype.forEach.call(deskMenuItems, function(el, i){
				let timer;
				el.addEventListener("mouseover", function(event){

					// Close all open menus imediately before opening current menu
					deskMenuItems.forEach(function(menu) {
						if (menu.classList.contains('open')) {
							closeDropdownMenu(menu);
						}
					});

					// Open moused over menu
					openDropdownMenu(el);

					// Reset Timer
					clearTimeout(timer);
				});
				el.addEventListener("mouseout", function(event){
					timer = setTimeout(function(event){
						el.classList.remove('open');
						closeDropdownMenu(el);
					}, 1000);
				});
			});
		}

		function initializeMenu() {
			deskMenuItems.forEach(menu => {
				// If parent needs to be clicked add dropdown indicator
				let activatingA = menu.querySelector('a');
				const btn = '<button><span><span class="visuallyhidden">show submenu for “' + activatingA.text + '”</span></span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"/></svg></button>';
				activatingA.insertAdjacentHTML('afterend', btn);

				let menuButtonToggle = menu.querySelector('button');

                // Open menu on click, not used if hover to open is used
              
				// menuButtonToggle.addEventListener("click",  event => {
				// 	if (menuButtonToggle.parentNode.classList.contains("open")) {
				// 		closeDropdownMenu(menuButtonToggle.parentNode);
				// 	} else {
				// 		openDropdownMenu(menuButtonToggle.parentNode);
				// 	}
				// 	event.preventDefault();
				// });

			});
		}
        function initializeMobileMenu() {
          	mobileMenuItems.forEach(menu => {
				// If parent needs to be clicked add dropdown indicator
				let activatingA = menu.querySelector('a');
				const btn = '<button><span><span class="visuallyhidden">show submenu for “' + activatingA.text + '”</span></span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"/></svg></button>';
				activatingA.insertAdjacentHTML('afterend', btn);

				let menuButtonToggle = menu.querySelector('button');

                // Open menu on click, not used if hover to open is used
              
				menuButtonToggle.addEventListener("click",  event => {
					if (menuButtonToggle.parentNode.classList.contains("open")) {
						closeDropdownMenu(menuButtonToggle.parentNode);
					} else {
						openDropdownMenu(menuButtonToggle.parentNode);
					}
					event.preventDefault();
				});

			});
        }

		// OPEN dropdown Menu
		function openDropdownMenu(menu) {
			menu.classList.add('open');
			ifSubMenuOffscreen(menu);
			menu.querySelector('a').setAttribute('aria-expanded', "true");
			menu.querySelector('button').setAttribute('aria-expanded', "true");
		}

		// CLOSE dropdown Menu
		function closeDropdownMenu(menu) {
			menu.classList.remove('open');
			menu.querySelector('a').setAttribute('aria-expanded', "false");
			menu.querySelector('button').setAttribute('aria-expanded', "false");
		}

		// If Dropdown menu goes offscreen, move back inscreen.
		function getOffset(el) {
			const rect = el.getBoundingClientRect();
			return {
				left: rect.left + window.scrollX,
				top: rect.top + window.scrollY
			};
		}

		function ifSubMenuOffscreen(menu) {
			var elm = menu.querySelector('ul');
			var l = getOffset(elm).left;
			var w = elm.clientWidth;
			var docW = window.innerWidth;
			let padEdge = 20; // Edge of screen padding, adjust as needed to move sub menu into screen

			var isEntirelyVisible = (l + w + padEdge <= docW);

			if (!isEntirelyVisible) {
				var difference = (l+w) - docW + padEdge;
				elm.style.left = (difference * -1) + "px";
			}
		}

	// Hamburger Mobile Menu click
	if (menuToggle) {
		menuToggle.addEventListener('click', function() {
		if(this.classList.contains('animate')) {
			this.classList.remove('animate');
			body.classList.remove('noscroll');
			mobileMenu.classList.remove('visible');
			this.setAttribute('aria-expanded', "false");
		} else {
			this.classList.add('animate');
			body.classList.add('noscroll');
			mobileMenu.classList.add('visible');
			this.setAttribute('aria-expanded', "true");
			if (searchToggle.classList.contains('animate')) {
				closeSearch(searchToggle);
			}
		}
	});
	}

/***** Search Toggle  *****/
const searchToggle = document.querySelector('.header-drk__search-toggle');
const siteSearchWrap = document.querySelector('.header-drk__search');
	if (searchToggle) {
		searchToggle.addEventListener('click', function() {
			if(this.classList.contains('animate')) {
				closeSearch(this);
			} else {
				openSearch(this);
				if (menuToggle.classList.contains('animate')) {
					menuToggle.classList.remove('animate');
					body.classList.remove('noscroll');
					mobileMenu.classList.remove('visible');
					menuToggle.setAttribute('aria-expanded', "false");
				}

			}
		});
	}
	function closeSearch(item) {
		item.classList.remove('animate');
		siteSearchWrap.classList.remove('visible');
		item.setAttribute('aria-expanded', "false");
	}
	function openSearch(item) {
		item.classList.add('animate');
		siteSearchWrap.classList.add('visible');
		item.setAttribute('aria-expanded', "true");
	}